import instance from "../utils/network";
import { CommonResponse, ReservationResponse } from "./types";

export interface CompanyReservationParams {
  reservationId: number;
  userId: number;
  route: string;
}
export interface ReservationCurrentResponse {
  nickname: string;
  id: number;
  userId: number;
  route: string;
}

export function registerCompanyReservation(
  data: CompanyReservationParams
): Promise<CommonResponse> {
  return instance.post("/nest/company-reservation/register", data);
}

export function cancelCompanyReservation(id: number): Promise<CommonResponse> {
  return instance.delete(`/nest/company-reservation/cancel/${id}`);
}

export function getCompanyReservation(
  id: string
): Promise<ReservationResponse> {
  return instance.get(`/nest/company-reservation/detail/${id}`);
}

export function getCompanyCurrentReservations(
  id: number
): Promise<ReservationCurrentResponse[]> {
  return instance.get(`/nest/company-reservation/current/${id}`);
}
